<template>
  <svg
    role="img"
    aria-label="Reco"
    viewBox="0 0 104 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use href="#reco-logo" />
  </svg>
</template>

<script>
export default {
  name: 'RecoLogo',
};
</script>
